import * as React from 'react';
import {Subheading} from './subheading';

interface LoadingPaneProps {
    title: string;    
}

export default class LoadingPane extends React.Component<LoadingPaneProps, any> {
    render() {
        return (
            <div className="container content">
                <Subheading title={this.props.title} />
                <div className="loader">
                </div>
            </div>
        )
    }
}
